export const css = {
    list: '_7GQCxnXN',
    listItem: 'EL574NVr',
    listLeading: '_5iDJFAJQ',
    listCenter: 'fYayB3Jh',
    listItemTitle: '_7s-X9k58',
    listItemTitleText: 'xmCaacZy',
    actions: 'SHAO-PFz',
    ' _key': 'mc-widgets/list-view'
};
export default css;
